module.exports = __webpack_public_path__ + "img/park-en.6cb179ab.jpg";